export enum Country {
  Kazakhstan = 'Kazakhstan',
  Russia = 'Russia',
}
